import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onDestroy } from 'svelte';
import { getLanguage, subscribeLanguageChange, t } from '../../i18n.ts';
import Button from '../svelte-button.svelte';
import StepRow from './svelte-step-row.svelte';
import StepWelcome from './svelte-step-welcome.svelte';

var root = $.from_html(`<div class="step-root svelte-xt2zkt"><!> <!></div>`);

const $$css = {
	hash: 'svelte-xt2zkt',
	code: '.step-root.svelte-xt2zkt {position:relative;z-index:4;flex:1;min-height:0;overflow:auto;padding:12px 12px 12px 0;display:flex;flex-direction:column;gap:10px;}[data-step-item="true"][data-dragging="true"] {opacity:0.42;}[data-step-item="true"][data-drop-position="before"] {box-shadow:inset 0 3px 0 var(--color-accent);}[data-step-item="true"][data-drop-position="after"] {box-shadow:inset 0 -3px 0 var(--color-accent);}.step-action-button {padding:4px 8px;font-size:11px;}.step-remove-button {color:var(--color-danger-text);}[data-step-socket="true"][data-socket-target="true"] {border-color:var(--color-socket-target-border);box-shadow:0 0 0 3px var(--color-accent-ring-strong);}[data-step-socket="true"][data-socket-source-active="true"] {border-color:var(--color-accent);box-shadow:0 0 0 3px var(--color-accent-ring);}.inline-add-button {width:100%;border-style:dashed;border-radius:12px;background:transparent;padding:8px;}.inline-add-button:hover {transform:none;border-color:var(--color-accent);background:color-mix(in srgb, var(--color-surface-inset), var(--color-accent) 8%);}'
};

export default function Svelte_step_list($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const steps = $.prop($$props, 'steps', 23, () => []),
		luts = $.prop($$props, 'luts', 23, () => []),
		customParams = $.prop($$props, 'customParams', 23, () => []),
		preservedScrollTop = $.prop($$props, 'preservedScrollTop', 7, 0),
		preservedScrollLeft = $.prop($$props, 'preservedScrollLeft', 7, 0),
		restoreNonce = $.prop($$props, 'restoreNonce', 7, 0),
		computeLutUv = $.prop($$props, 'computeLutUv', 7, undefined);

	function dispatch(eventName, detail) {
		$$props.$$host.dispatchEvent(new CustomEvent(eventName, { detail, bubbles: true, composed: true }));
	}

	let language = $.state($.proxy(getLanguage()));
	let scrollRoot = $.state(null);

	const scrollState = {
		savedTop: 0,
		savedLeft: 0,
		restoring: false,
		appliedRestoreNonce: -1,
		appliedRestoreNode: null
	};

	const disposeLanguageSync = subscribeLanguageChange((nextLanguage) => {
		$.set(language, nextLanguage, true);
	});

	function tr(key, values) {
		$.get(language);

		return values ? t(key, values) : t(key);
	}

	function emitStatus(message, kind = 'info') {
		dispatch('status-message', { message, kind });
	}

	function captureScrollPosition(syncParent = false) {
		if (!$.get(scrollRoot)) {
			return;
		}

		scrollState.savedTop = $.get(scrollRoot).scrollTop;
		scrollState.savedLeft = $.get(scrollRoot).scrollLeft;

		if (syncParent && !scrollState.restoring) {
			dispatch('schedule-connection-draw');
		}
	}

	function restoreScrollPosition(target) {
		target.scrollTop = scrollState.savedTop;
		target.scrollLeft = scrollState.savedLeft;
	}

	function bindScrollRoot(node) {
		$.set(scrollRoot, node, true);
		scrollState.savedTop = node.scrollTop;
		scrollState.savedLeft = node.scrollLeft;

		return {
			destroy: () => {
				if ($.get(scrollRoot) === node) {
					$.set(scrollRoot, null);
				}
			}
		};
	}

	function handleAddStepClick() {
		captureScrollPosition();
		dispatch('add-step');
	}

	function handleStepMuteChange(stepId, muted) {
		dispatch('step-mute-change', { stepId, muted });
	}

	function handleDuplicateStep(stepId) {
		dispatch('duplicate-step', { stepId });
	}

	function handleRemoveStep(stepId) {
		dispatch('remove-step', { stepId });
	}

	function handleStepLabelChange(stepId, label) {
		dispatch('step-label-change', { stepId, label });
	}

	function handleStepLutChange(stepId, lutId) {
		dispatch('step-lut-change', { stepId, lutId });
	}

	function handleStepBlendModeChange(stepId, blendMode) {
		dispatch('step-blend-mode-change', { stepId, blendMode });
	}

	function handleStepOpChange(stepId, channel, op) {
		dispatch('step-op-change', { stepId, channel, op });
	}

	$.user_effect(() => {
		const node = $.get(scrollRoot);

		if (!node) {
			return;
		}

		const nextRestoreNonce = restoreNonce();

		if (nextRestoreNonce === scrollState.appliedRestoreNonce && node === scrollState.appliedRestoreNode) {
			return;
		}

		if (!(preservedScrollTop() === 0 && scrollState.savedTop > 0)) {
			scrollState.savedTop = preservedScrollTop();
		}

		if (!(preservedScrollLeft() === 0 && scrollState.savedLeft > 0)) {
			scrollState.savedLeft = preservedScrollLeft();
		}

		scrollState.appliedRestoreNonce = nextRestoreNonce;
		scrollState.appliedRestoreNode = node;
		scrollState.restoring = true;
		restoreScrollPosition(node);

		requestAnimationFrame(() => {
			if ($.get(scrollRoot) !== node) {
				scrollState.restoring = false;

				return;
			}

			restoreScrollPosition(node);

			requestAnimationFrame(() => {
				if ($.get(scrollRoot) !== node) {
					scrollState.restoring = false;

					return;
				}

				restoreScrollPosition(node);
				scrollState.restoring = false;
				dispatch('schedule-connection-draw');
			});
		});
	});

	onDestroy(() => {
		disposeLanguageSync();
	});

	var $$exports = {
		get steps() {
			return steps();
		},

		set steps($$value = []) {
			steps($$value);
			$.flush();
		},

		get luts() {
			return luts();
		},

		set luts($$value = []) {
			luts($$value);
			$.flush();
		},

		get customParams() {
			return customParams();
		},

		set customParams($$value = []) {
			customParams($$value);
			$.flush();
		},

		get preservedScrollTop() {
			return preservedScrollTop();
		},

		set preservedScrollTop($$value = 0) {
			preservedScrollTop($$value);
			$.flush();
		},

		get preservedScrollLeft() {
			return preservedScrollLeft();
		},

		set preservedScrollLeft($$value = 0) {
			preservedScrollLeft($$value);
			$.flush();
		},

		get restoreNonce() {
			return restoreNonce();
		},

		set restoreNonce($$value = 0) {
			restoreNonce($$value);
			$.flush();
		},

		get computeLutUv() {
			return computeLutUv();
		},

		set computeLutUv($$value = undefined) {
			computeLutUv($$value);
			$.flush();
		}
	};

	var fragment = $.comment();
	var node_1 = $.first_child(fragment);

	$.key(node_1, () => $.get(language), ($$anchor) => {
		var div = root();
		var node_2 = $.child(div);

		{
			var consequent = ($$anchor) => {
				var fragment_1 = $.comment();
				var node_3 = $.first_child(fragment_1);

				$.each(node_3, 19, steps, (step) => step.id, ($$anchor, step, index) => {
					StepRow($$anchor, {
						get step() {
							return $.get(step);
						},

						get stepIndex() {
							return $.get(index);
						},

						get luts() {
							return luts();
						},

						get customParams() {
							return customParams();
						},
						tr,
						onCaptureScroll: () => captureScrollPosition(true),
						onStepMuteChange: handleStepMuteChange,
						onDuplicateStep: handleDuplicateStep,
						onRemoveStep: handleRemoveStep,
						onStepLabelChange: handleStepLabelChange,
						onStepLutChange: handleStepLutChange,
						onStepBlendModeChange: handleStepBlendModeChange,
						onStepOpChange: handleStepOpChange,
						get computeLutUv() {
							return computeLutUv();
						},
						onStatus: emitStatus
					});
				});

				$.append($$anchor, fragment_1);
			};

			var alternate = ($$anchor) => {
				StepWelcome($$anchor, {
					tr,
					onStatus: emitStatus,
					onOpenPipelineFilePicker: () => dispatch('open-pipeline-file-picker'),
					onLoadExample: (example) => {
						dispatch('load-example', { example });
					}
				});
			};

			$.if(node_2, ($$render) => {
				if (steps().length > 0) $$render(consequent); else $$render(alternate, -1);
			});
		}

		var node_4 = $.sibling(node_2, 2);

		Button(node_4, {
			variant: 'secondary',
			className: 'inline-add-button',
			blurOnPress: true,
			handleMouseDown: (event) => {
				captureScrollPosition(true);
				event.preventDefault();
			},
			handlePress: handleAddStepClick,
			children: ($$anchor, $$slotProps) => {
				$.next();

				var text = $.text();

				$.template_effect(($0) => $.set_text(text, $0), [() => tr('pipeline.step.add')]);
				$.append($$anchor, text);
			},
			$$slots: { default: true }
		});

		$.reset(div);
		$.action(div, ($$node) => bindScrollRoot?.($$node));

		$.event('scroll', div, () => {
			if (scrollState.restoring) {
				return;
			}

			captureScrollPosition();
			dispatch('schedule-connection-draw');
		});

		$.append($$anchor, div);
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

customElements.define('lut-step-list', $.create_custom_element(
	Svelte_step_list,
	{
		steps: {},
		luts: {},
		customParams: {},
		preservedScrollTop: {},
		preservedScrollLeft: {},
		restoreNonce: {},
		computeLutUv: {}
	},
	[],
	[]
));